import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
const initialState: ActionBoxCategory = {
  ActionBoxCategoryID: null,
  TenantID: null,
  CategoryName: '',
  UiPosition: null,
  iconImageUrl: '',
  actionBoxes: [],
  Name: '',
  selectedLanguage: '',
  selectedLanguageName: '',
  defaultLanguage: {
    Name: null
  },
  translations: {
    Name: null,
    LanguageCode: null
  }
};
export const actionBoxCategorySlice = createSlice({
  name: 'actionBoxCategory',
  initialState,
  reducers: {
    setActionBoxCategoryInfo: (state, action: PayloadAction<ActionBoxCategory>) => {
      return {
        ...state,
        ...action.payload
      };
    },
    setActionBoxCategorySelectedTranslations: (state, action: PayloadAction<SetCategoryTranslationParms>) => {
      return {
        ...state,
        selectedLanguage: action.payload.selectedLanguage,
        selectedLanguageName: action.payload.selectedLanguageName,
        defaultLanguage: action.payload.defaultLanguage,
        translations: {
          Name: action.payload.translations?.Name ?? null,
          LanguageCode: action.payload.selectedLanguage
        }
      };
    }
  }
});
export const {
  setActionBoxCategoryInfo,
  setActionBoxCategorySelectedTranslations
} = actionBoxCategorySlice.actions;
export const actionBoxCategoryReducer = actionBoxCategorySlice.reducer;